import React, { useEffect, useState } from 'react';
import 'survey-core/defaultV2.min.css';
import { PopupSurvey } from 'survey-react-ui';
import { Model } from 'survey-core';
import 'survey-core/survey.i18n';

export default function PopupSurveyLayout(props) {

  const surveyJson = new Model(props.survey.survey_json);
  surveyJson.locale = props.userLanguage;
  if (props.surveyResults && !!props.surveyResults.results) {
    const results = props.surveyResults.results;
    for (const result of results) {
      const question = surveyJson.getQuestionByName(result.question.question_json.name);
      question.value = result.answer;
    }
  }

  // when completed
  surveyJson.onComplete.add((sender, options) => {
    props.completeFn(sender.data);
  });

  useEffect(() => {
    document.getElementsByClassName('sv-string-viewer')[0].innerHTML = '<span>Please complete our survey for this content!&nbsp&nbsp&nbsp<i class="ui small happy icon"></i></span>';
    document.getElementsByClassName('sv_window')[0].style.cssText = "position:fixed;min-width:20%;background-color:var(--primary);font-family:var(--font-family);";
    document.getElementsByClassName('sv_window_title')[0].style.cssText = "background-color:var(--primary);color:var(--background);align-text:center;border-bottom:0px;";
  })

  return (
      <PopupSurvey model={surveyJson} isExpanded={props.expandSurvey} />
  );
}